import { render, staticRenderFns } from "./tableInnerHeader.vue?vue&type=template&id=56dd0fc8"
import script from "./tableInnerHeader.vue?vue&type=script&lang=js"
export * from "./tableInnerHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports